import SelectData from "../interface/IInputSelect";
import { PropType } from "vue";

export default {
  modelValue: {
    type: [String, Number],
    required: false,
    default: "",
  },
  options: {
    type: Array as PropType<SelectData[]>,
    default: () => [],
  },
};
